import { ApplicationState } from '../main/types';

export const selectNavbarOptions = (state: ApplicationState) =>
  state.ui.navbarOptions;
